var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"settings-fieldset-interior-item settings-fieldset-interior-item--timezone"},[_c('TimezonePicker',{attrs:{"additional-timezones":_vm.additionalTimezones,"value":_vm.timezone},on:{"input":_vm.setTimezoneValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }